const RULES = {
  required: {
    method: value => value !== undefined && value !== null && value.length > 0,
    error: '必填信息，不能为空'
  },

  email: {
    method: value =>
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
        value
      ),
    error: '邮箱格式有误'
  },

  mobile: {
    method: value => /^\d{11}$/.test(value),
    error: '手机号码必须为11位'
  },

  mobile8: {
    method: value => /^\d{8}$/.test(value),
    error: '香港/澳门手机号码必须为8位'
  },

  mobile9: {
    method: value => /^\d{9}$/.test(value),
    error: '台湾手机号码必须为9位'
  },

  password: {
    method: value => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/.test(value),
    error: '密码至少8位且必须包含大小写字母和数字'
  },

  smsCode: {
    method: value => /^\d{6}$/.test(value),
    error: '短信验证码必须为6位数字'
  },

  inviteCode: {
    method: value => /^\d{6}$/.test(value),
    error: '邀约码必须为6位数字'
  },

  companyCode: {
    method: value => /^\d{8}$/.test(value),
    error: '携客企业号必须为8位数字'
  },

  creditCode: {
    method: value => /(^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$)|(^\d{15}$)/.test(value),
    error: '企业统一社会信用代码必须为18位的数字或大写字母/工商注册号必须为15位数字'
  },

  number: {
    method: value => /^-?\d+(\.\d+)?$/.test(value),
    error: '无效数字格式'
  }
};


const Validation = {

  //验证单字段
  validate(config, key, error) {
    let result = true;
    if (key in config) {
      let value = config[key].value;
      let rules = config[key].rules;
      result = this.test(key, value, rules, error);
    }
    return result;
  },

  //验证所有字段
  validateAll(config, error) {
    let n = 0;
    Object.keys(config).forEach(key => {
      n += this.validate(config, key, error) ? 0 : 1;
    });
    return n === 0 ? true : false;
  },

  //直接调用验证方法
  test(key, value, rules, error) {
    let result = true;
    for (let ruleName of rules) {
      if (!(ruleName in RULES)) {
        //规则不存在
        break;
      }
      if (ruleName !== 'required' && [undefined, null, ''].indexOf(value) > -1) {
        //非必填且值为空
        continue;
      }
      if (!RULES[ruleName].method(value)) {
        error[key] = RULES[ruleName].error;
        result = false;
        break;
      } else {
        error[key] = undefined;
      }
    }
    return result;
  },

  //获取验证方法
  getMethod(ruleName) {
    if (RULES[ruleName] !== undefined) {
      return RULES[ruleName].method;
    } else {
      return value => false;
    }
  }
};

export default Validation;
